import type { FC } from 'react';

import Link from 'components/Link';

import type { LinkMenuItemProps } from './types';

const LinkMenuItem: FC<LinkMenuItemProps> = ({
  location,
  children,
  className,
}) => {
  const to = location || '#';

  if (!location) {
    console.warn('Provide location property for bottom menu item');
  }

  return (
    <Link to={to} activeStrategy="nested" className={className}>
      {children}
    </Link>
  );
};

export default LinkMenuItem;
